'use client';

// import { DroneScene } from './splite';
import { Card } from './card';
import { Spotlight } from './spotlight';
// import { SpotlightMotion } from './spotlight-motion';

export function SplineSceneBasic() {
  return (
    <Card className="relative w-full overflow-hidden border-white/20 bg-black/[0.96]">
      <Spotlight className="-top-40 left-0 md:left-60 md:-top-20" fill="white" />

      <div className="flex h-full flex-col md:flex-row md:items-center">
        <div className="relative z-10 flex flex-1 flex-col justify-center px-8 py-8 text-center md:px-10 md:py-10 md:text-left">
          <div className="mx-auto w-full max-w-[46rem] md:mx-0">
            <h1 className="bg-gradient-to-b from-neutral-50 to-neutral-400 bg-clip-text text-4xl font-bold text-transparent md:text-5xl">
              Mission-ready camera systems and autonomous ground vehicles
            </h1>
            <p className="mt-4 max-w-lg text-white md:max-w-xl">
              Valinor Dynamics is a dual-tech company building camera-driven systems and
              autonomous ground platforms for persistent awareness, tracking, and response.
            </p>
          </div>
        </div>

        {/* <div className="relative flex flex-1 items-center justify-center px-4 pb-8 md:basis-[58%] md:px-8 md:pb-0">
          <SpotlightMotion
            size={320}
            className="z-20 from-white/70 via-neutral-200/45 to-transparent"
          />
          <DroneScene className="h-[320px] w-full max-w-[540px] md:h-[440px] md:max-w-[620px]" />
        </div> */}
      </div>
    </Card>
  );
}
